import { render } from "./OrderSummaryChart.vue?vue&type=template&id=52b8f504&ts=true"
import script from "./OrderSummaryChart.vue?vue&type=script&lang=ts"
export * from "./OrderSummaryChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__